import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vb_token") || localStorage.getItem("vb_member_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      localStorage.removeItem("vb_token");
      localStorage.removeItem("vb_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/f/") && !window.location.pathname.startsWith("/member")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const brl = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const saveAuth = (token, user) => {
  localStorage.setItem("vb_token", token);
  localStorage.setItem("vb_user", JSON.stringify(user));
};
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("vb_user")); } catch { return null; }
};
export const logout = () => {
  localStorage.removeItem("vb_token");
  localStorage.removeItem("vb_user");
  window.location.href = "/";
};

export const errMsg = (err, fallback = "Erro") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" · ");
  if (d) return JSON.stringify(d);
  return err?.message || fallback;
};
